import {buildTileActionButtons, Tile, TileProps,} from "../components/Tile.tsx";
import {watchJobByIdTqo} from "../rpc/webrpc-client.gen.ts";
import {ActionButtonProps} from "../components/ActionButton.tsx";
import {ShinwaJobCapsule} from "./capsule.tsx";
import {useMemo} from "react";
import {SuspenseDialog} from "../components/SuspenseDialog.tsx";
import {Keyed} from "../util/arutil.tsx";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {useMothership} from "../tq/tqx.tsx";

export interface ShinwaJobTileProps extends Omit<TileProps, "Subject" | "actions"> {
    jobId: string;
    actionProps?: Keyed<ActionButtonProps>[];
//    linkify?: boolean;
}

export function ShinwaJobTile(props: ShinwaJobTileProps) {
    const {
        jobId,
        actionProps,
        ...rest
    } = props;
    const mama = useMothership();
    const tqrv = useInfallibleQuery(watchJobByIdTqo(mama, {jobId}));
    const job = tqrv.data;
    const actions = useMemo(() => {
       return buildTileActionButtons(actionProps);
    }, [actionProps]);

    if (!job) {
        return <SuspenseDialog message="loading job..."/>;
    }

    return <Tile {...rest} Subject={(props) =>
                <ShinwaJobCapsule job={job} {...props}/>}
                 actions={actions}
    />
}

